import { DatePipe } from '@angular/common';
import { Paginazione } from 'src/app/shared/models/paginazione';
export class Filtri_Spedizione extends Paginazione {
  datepipe? = new DatePipe('it-it');
  inizio?: string;
  fine?: string;
  corriere?: number;
  filtro?: string;
  stato?: string;
  agenzia?: string;
  ids?: number[];
  contrassegno?: boolean;
  t12?: boolean;
  ritiro?: boolean;
  triangolazione?: boolean;
  internazionali?: boolean;
  nazionali?: boolean;
  pratiche?: boolean;
  chiuse?: boolean;
  codice?: string;
  fattura?: boolean;
  constructor(page: number, size: number, inizio?: string | Date, fine?: string | Date) {
    super(page, size);
    const today = new Date();
    const inizioMese = new Date(today.getFullYear(), 0, 1);
    const fineMese = new Date(today.getFullYear() + 1,  0, 0);
    this.inizio = this.datepipe.transform(inizio || inizioMese, 'yyyy-MM-dd');
    this.fine = this.datepipe.transform(fine || fineMese, 'yyyy-MM-dd');
    this.contrassegno = false;
    this.t12 = false;
    this.ritiro = false;
    this.pratiche = false;
    this.chiuse = false;
    this.fattura = false;
    this.triangolazione = false;
    this.internazionali = false;
    this.nazionali = false;
  }
}
